<template>
    <div>
        <Line v-show="show_chart" :data="chartData" :options="chartOptions"/>
        <table class="table w-full border">
            <thead>
                <tr>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="shipping_name">Name</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="shipping_email">Email Address</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-center border-b-2 border-gray py-2 px-2" sort-by="order_count"># of Orders</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="avg_sale">Avg. Sale</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="total_sales">Total Sales</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data.results" :key="item.id">
                    <td>{{ item.shipping_name }}</td>
                    <td>{{ item.shipping_email }}</td>
                    <td class="text-center">{{ item.order_count }}</td>
                    <td class="text-right">${{ item.avg_sale }}</td>
                    <td class="text-right">${{ Number(item.total_sales).toFixed(2) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { Line } from 'vue-chartjs';
import SortableHeader from '@/Shared/SortableHeader';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export default {
    name: 'CustomerSales',

    components: {
        SortableHeader,
        Line,
    },

    props: ['data', 'show_chart', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    computed: {
        chartData() {
            return {
                labels: this.data.chart_data.labels,
                datasets: [
                    {
                        label: 'First-time Customers',
                        data: this.data.chart_data.new,
                        fill: 'origin',
                        backgroundColor: 'rgba(51, 113, 255, 0.3)',
                        borderColor: '#3371FF',
                    },
                    {
                        label: 'Returning Customers',
                        data: this.data.chart_data.returning,
                        fill: '-1',
                        backgroundColor: 'rgba(51, 255, 113, 0.3)',
                        borderColor: '#33FF71',
                    },
                ]
            }
        },

        chartOptions() {
            return {
                elements: {
                    line: {
                        tension: 0
                    }
                },
                plugins: {
                    filler: {
                        propagate: true
                    }
                }
            }
        },
    },

    methods: {
        handleSort(sort) {
            this.$emit('sort', sort, 'results');
        },
    },
}
</script>